"use strict";
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isObject = isObject;
function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : _type_of(value);
    return value !== null && (type === 'object' || type === 'function');
} //# sourceMappingURL=isObject.js.map
